import styled from "styled-components";
import { ButtonSettings, ArrowScroll, Text } from "../../../services/visualLibraryService";
import { shadowStyled } from "../../../styles/shared-styles";
import { i18n } from "../../../services/i18nService";

export const LayoutStyled = styled.section`
  width: 100%;
  top: 0;
  bottom: 0;
  transition: transform 0.2s linear;
  &::after {
    opacity: 0;
  }
  /* Showing shadows when the layout has content */
  &.hasContent {
    &::before {
      ${props =>
        shadowStyled(
          "top",
          // "-0.5vw",
          `${props.theme.baseLayoutPaddingBs * 3}%`,
          props.theme.backgroundRGB,
          0,
          props.theme.zIndex.base
        )};
    }
  }
  /* Showing shadow inside before when the layout is scrolling */
  &.isLayoutScrolling {
    &::before {
      opacity: 1;
    }
    /* FIXME: To remove with the new layout + carousel implementation */
    article,
    article + div {
      transform: ${props => `translateY(-${props.position}px)`};
    }
  }

  ${props =>
    !props.isHeroAndBanner
      ? `
    &.noHero {
      margin-top: 8.2rem;
  `
      : ``}

  article:nth-child(2n) {
    transform: ${props => `translateY(-${props.position}px)`};
    -webkit-transform: ${props => `translateY(-${props.position}px)`};
    -ms-transform: ${props => `translateY(-${props.position}px)`};
  }
  & .Styled__ImageContainerStyled-t5q7es-1 {
    position: relative;
    width: 100%;
  }
  article.focused .selected svg {
    fill: ${props => props.theme.color.primary} !important;
  }
  & .selected span {
    opacity: 1 !important;
  }

  & .channelCarosal .slide div div:first-child img {
    margin-top: -0.5px;
    visibility: visible;
  }
  & .channelCarosal .slide.selected div div:first-child img {
    visibility: visible;
  }
`;

/* TODO: review this shadow in the new Header + Layout + carousel refactorization */
/* prettier-ignore */
export const ShadowLayoutStyled = styled.div`
  ${props =>
    shadowStyled("bottom", "1.5vw", `${props.theme.baseLayoutPaddingBs * 3}%`, '#27324E;' || props.theme.backgroundRGB, 1, props.theme.zIndex.base)};
  transition: opacity 0.3s ease-in-out;
  transform: translateY(-1.8rem);
  -webkit-transform: translateY(-1.8rem);
  -ms-transform: translateY(-1.8rem);
  /* Removing shadow inside after when the layout ends */
  ${LayoutStyled}.isLayoutEnd ~ & {
    opacity: 0;
  }
`;

export const ButtonStyled = styled(ButtonSettings)`
  margin: 0 auto ${props => props.theme.spacing.xsmall};
  transform: translateY(-0.5rem);
  margin-${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: 4.167rem;
`;

export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  top: -${props => props.theme.spacing.large};
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.2s linear;
  will-change: opacity;
  opacity: ${props => (props.isVisible ? 1 : 0)};
`;

export const LayoutEmptyStyled = styled.div`
  text-align: center;
  padding-top: ${props => props.theme.baseLayoutPaddingBs}%;
`;

export const HeroBanner = styled.div`
  display: flex;
  height: 8.625rem;
  width: 95.5rem;
  color: #2e2626;
  z-index: 99999;
  justify-content: space-between;
  ${props =>
    props.isActive &&
    `
      &.noHero {
        position: relative;
        margin-bottom: 2rem;
      }
    `}
  position: absolute;
  border-radius: 0.5rem;
  background-color: rgba(0, 0, 0, 0.7);
  transform: ${props =>
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT
      ? "translate(-2.188rem, 1.5rem)"
      : "translate(2.188rem, 1.5rem)"};
  -webkit-transform: ${props =>
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT
      ? "translate(-2.188rem, 1.5rem)"
      : "translate(2.188rem, 1.5rem)"};
`;

export const ContainerStyled = styled.div`
  display: flex;
  ${props => (props.ctaTextLength >= 25 ? `width: 63%;` : `width: 60%;`)}
  justify-content: flex-start;
  -webkit-align-items: center;
  -webkit-box-align: center;
  align-items: center;
  height: 100%;
  ${props =>
    props.flexTextRTL &&
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT &&
    `
  justify-content: flex-start;`};
`;

export const ImageBannerStyled = styled.img`
  height: 6rem;
  width: 25%;
`;

export const TextStyled = styled(Text)`
  font-weight: normal;
  // margin-bottom: ${props => props.theme.spacing.small};
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: ${props =>
  props.theme.spacing.small};
  font-size: 1.5rem;
  min-width: 50rem;
  // text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  ${props =>
    props.flexTextRTL &&
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT &&
    `display: flex;
  flex-direction: column;
  margin-bottom: 0`};
`;

export const ContainerButtonStyled = styled.div`
  /* ${props => (props.ctaTextLength >= 25 ? `width: 37%;` : `width: 40%;`)} */
  align-items: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  display: flex;
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  display: block;
  font-size: ${props => props.theme.font.size.default};
  ${props =>
    props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT
      ? `margin-right: ${props.theme.spacing.default};
         margin-left: auto;`
      : `margin-left: ${props.theme.spacing.default};
         margin-right: auto;`}
  letter-spacing: 0;
  svg {
    vertical-align: baseline;
    width: 2rem;
    height: 2rem;
    fill: #fff;
  }
`;
